enum FunnelKey {
  amazon = "amazon",
  cdc_dpp = "cdcdpp",
  demo = "demo",
  eternalHealth = "eternalhealth",
  evernorth = "evernorth",
  kwikTrip = "kwiktrip",
  lilly = "lilly",
  lillyTeam = "lilly-team",
  medicare = "medicare",
  none = "_none_",
  novocare = "novocare",
  prescryptive = "prescryptive",
  promo = "promo",
  smithrx = "smithrx",
  solera = "wellvolution",
  stateOfIndiana = "state-of-indiana",
  test = "test",
  transcarent = "transcarent",
  treatmentPlan = "treatment-plan",
  universal = "universal",
  weightLoss = "weight-loss",
  wipfli = "wipfli"
}

export default FunnelKey;
